import React from 'react';
import { TOTAL_DAYS } from '../data/constants';
import { useI18n } from '../i18n';

export default function DayMeter({ day, style, accent }) {
  const { t } = useI18n();
  const dayLabel = t.ui.dayLabel;
  if (style === 'ring') {
    const r = 22;
    const c = 2 * Math.PI * r;
    const pct = day / TOTAL_DAYS;
    return (
      <div className="daymeter daymeter--ring">
        <svg viewBox="0 0 56 56" width="56" height="56">
          <circle cx="28" cy="28" r={r} fill="none" stroke="#EEE" strokeWidth="3" />
          <circle
            cx="28" cy="28" r={r}
            fill="none" stroke={accent} strokeWidth="3"
            strokeDasharray={c}
            strokeDashoffset={c * (1 - pct)}
            strokeLinecap="round"
            transform="rotate(-90 28 28)"
          />
        </svg>
        <div className="daymeter__num">{day}</div>
        <div className="daymeter__lbl">{dayLabel}</div>
      </div>
    );
  }
  return (
    <div className="daymeter daymeter--text">
      <span className="daymeter__big">{day}</span>
      <span className="daymeter__sep">/</span>
      <span className="daymeter__total">{TOTAL_DAYS}</span>
      <div className="daymeter__lbl">{dayLabel}</div>
    </div>
  );
}
